import {
  GET_TRENDING_REQUEST,
  GET_TRENDING_SUCCESS,
  GET_TRENDING_ERROR
} from "../actions/trendingActions";

const initialState = {
  loading: false,
  trendingEvents: null,
  error: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRENDING_REQUEST:
      return {
        ...state,
        loading: true,
        trendingEvents: null,
        error: false
      };
    case GET_TRENDING_SUCCESS:
      return {
        ...state,
        loading: false,
        trendingEvents: action.trendingEvents
      };
    case GET_TRENDING_ERROR:
      return {
        ...state,
        loading: false,
        error: false
      };
    default:
      return state;
  }
};
